import { css } from "styled-components";
import token from "styled-token";
import { StyledIcon } from "../../components/Icon/Icon";
import { spaceMixin } from "../spaceMixin";
import { typographyMixin } from "../typographyMixin";
import { iconOffsetMixin } from "../iconOffsetMixin";
import { marginMixin } from "../marginMixin";
export var DropdownHeadingMixin = function DropdownHeadingMixin(props) {
  return token({
    backgroundColor: "DropdownHeading.backgroundColor",
    fontType: "DropdownHeading.fontType",
    fontColor: "DropdownHeading.fontColor",
    iconSize: "DropdownHeading.iconSize",
    horizontalSpacing: "DropdownHeading.horizontalSpacing",
    verticalSpacing: "DropdownHeading.verticalSpacing"
  }, function (_ref) {
    var backgroundColor = _ref.backgroundColor,
        fontType = _ref.fontType,
        fontColor = _ref.fontColor,
        iconSize = _ref.iconSize,
        horizontalSpacing = _ref.horizontalSpacing,
        verticalSpacing = _ref.verticalSpacing;
    return css(["", " ", " background-color:", ";box-sizing:border-box;color:", ";margin:0;padding:", "px ", "px;text-transform:uppercase;&:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit;}", " > ", "{color:inherit;flex-shrink:0;margin-right:", ";}"], typographyMixin(Object.assign({
      fontType: fontType,
      fontTypeIconAlignment: false
    }, props)), iconOffsetMixin(Object.assign({}, props, {
      iconSize: iconSize
    })), backgroundColor, fontColor, verticalSpacing, horizontalSpacing, marginMixin(props), StyledIcon, spaceMixin("xs")(props));
  })(props);
};